import type { SaveStatus } from '@/hooks/useChinWorkspacePersistence';

// Small cloud-save status light: amber spinner while writing,
// green when saved, red on error, invisible (space reserved) when idle.
export default function SyncStatusDot({ status }: { status: SaveStatus }) {
  const base = 'w-2.5 h-2.5 rounded-full shrink-0';
  if (status === 'syncing') {
    return (
      <span
        className={`${base} border-2 border-amber-400 border-t-transparent animate-spin`}
        title="Đang đồng bộ lên cloud..."
      />
    );
  }
  if (status === 'saved') {
    return <span className={`${base} bg-emerald-400`} title="Đã lưu lên cloud" />;
  }
  if (status === 'error') {
    return <span className={`${base} bg-red-400`} title="Lỗi khi lưu lên cloud" />;
  }
  return <span className={`${base} bg-foreground-300 opacity-0`} title="Đồng bộ cloud" />;
}